import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './workflows.action';

@Injectable({ providedIn: 'root' })
export class WorkflowsTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                created_at: '',
                dossier_id: '',
                debtor_name: '',
                club_name: null,
                outstanding_with_fee: '',
                season_name: ''
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    
    clubs = [];

    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date", widthSet: 155},
                { prop: 'dossier_id', name: 'WORKFLOW.dossier-id', sortable: true, hasFilter: true, filter: "input", widthSet: 100},
                { prop: 'debtor_name', name: 'WORKFLOW.debtor-name', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'club_name', name: 'WORKFLOW.club', sortable: true, hasFilter: true, filter: "select", options: 'clubs', options_id: "id", options_label: "club_name"},
                { prop: 'outstanding_with_fee', name: 'WORKFLOW.outstanding', sortable: true, hasFilter: true, filter: "input", widthSet: 110},
                { prop: 'season_name', name: 'WORKFLOW.season-name', sortable: true, hasFilter: true, filter: "input", widthSet: 150}
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){
        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetState(){
        this.filters = {
            created_at: '',
            dossier_id: '',
            debtor_name: '',
            club_name: null,
            outstanding_with_fee: '',
            season_name: ''
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;
    }

    resetFilters(){
        this.resetState();
        this.loadRecords();
    }

}